module.exports = __webpack_public_path__ + "img/steam.9d3f62fa.png";